import { field, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { CONTACTS_SCHEMA } from '../schema';

export default class Contacts extends Model {
    static table = CONTACTS_SCHEMA

    static associations = {
        customer: { type: 'belongs_to', key: 'customer_id' },
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @text('contact_id') contact_id;
    @text('phone') phone;
    @text('name') name;
    @text('hash') hash;

    @relation('customer', 'customer_id') customer;
    @relation('user', 'user_id') user;

}